import React from 'react';
import './Accounts.css';
import { UserAuth, upload } from '../context/AuthContext';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getDoc, addDoc, doc, updateDoc, deleteDoc, setDoc, collection, getDocs, query, where, onSnapshot } from "@firebase/firestore";
import {db, storage } from '../firebase-config';
import { ref, uploadBytes, getDownloadURL, listAll } from 'firebase/storage'

import { Disposition } from '../models/Disposition.model.js';
import { dogBreeds } from '../models/dogBreeds.data';
import { catBreeds } from '../models/catBreeds.data';

import { Button, Input, IconButton, TextField, Card, CardActions } from '@mui/material/';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import Divider from '@mui/material/Divider';

import Typography from '@mui/material/Typography';
import InputAdornment from '@mui/material/InputAdornment';
import { makeStyles } from '@mui/styles';
import { PhotoCamera } from '@mui/icons-material/';
import Box from '@mui/material/Box';
import { spacing, styled } from '@mui/system';
import AddIcon from '@mui/icons-material/Add';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

const useStyles = makeStyles({
  field: {
    marginTop: 20,
    marginBottom: 20,
    display: 'block'
  }
})

const Account = () => {
  const { currentUser } = UserAuth();
  const [accountModel, setaccountModel] = useState([]);

  // Account details for DB
  const [userAccountDetails, setUserAccountDetails] = useState({});

  // Profile picture; linked to user id
  const [photo, setPhoto] = useState('./images/p2.jpg');
  const [loading, setLoading] = useState(false);
  const [photoURL, setPhotoURL] = useState('./images/p2.jpg');

  async function addPetToPetsCollection(){
    const colRef = collection(db, 'pets');
  
    await setDoc(doc(colRef), {
        shelterID: "fghfshsfghfdghfdgh",
        name: "Scooby",
        species: "dog", 
        breed: "great dane", 
        disposition: "goofy", 
        availability: "available",
        age: 5,
        description: "Clumsy, cowardly, insatiable appetite",
        imgUrl: "www.image.com"
      }

    );
  }
  const [mounted, setMounted] = useState(true);
  const toggle = () => setMounted(!mounted);
  // Pet details for DB
  const [shelterPets, setShelterPets] = useState([])
  const [imageUpload, setImageUpload] = useState(null)
  const [petImages, setPetImages] = useState({})
  const [petFormFields, setPetFormFields] = useState(
    {         
      shelterID: currentUser.uid,
      name: " ",
      species: " ", 
      breed: " ", 
      disposition: " ", 
      availability: "available",
      age: " ",
      description: "",
      imgUrl: "www.image.com"
    }
  );

  const handleFormChange = (e, index) => {
    let data = [...petFormFields];
    data[index][e.target.name] = e.target.value;
    setPetFormFields(data);
  };

  const addFields = () => {
    let object = {
      age: " ",
      breed: " ",
      description: " ", 
      disposition: " ",
      species: " "
    }
    setPetFormFields([...petFormFields, object])
  };

  const removeFields = (index) => {
    let data = [...petFormFields];
    data.splice(index, 1)
    setPetFormFields(data)
  };

  const uploadImage = (id) => {
    if (imageUpload == null) return;
    const imageRef = ref(storage, `images/pets/${id}`)
    uploadBytes(imageRef, imageUpload).then(() => {
      alert("Pet Image Uploaded")
    })
  };

  const Dropdown = ({ name, label, options, onChange, def }) => {
    return (
      <FormControl sx={{ m: 1, width: 300 }}>
      <label>
        {label}
        </label>
        <select name={name} id={label} onChange={(e) => onChange(e)}>
            <option key={"0"} value="name" defaultValue>{def}</option>      
            {options.map((option, index) => (
                <option key={index+1} value={option}>{option}</option>
            ))}
        </select>
      
      </FormControl>
    );
  };

  function handlePicChange(e) {
    if (e.target.files[0]) {
      setPhoto(e.target.files[0])
    }
    setLoading(true)
    
  };

  function handlePicClick() {
    upload(photo, currentUser, setLoading);
  };

  const [random, setRandom] = useState(Math.random());
  const reRender = () => setRandom(Math.random());

  const getUsers = async () => {
    const accountRef = doc(db, "accounts", currentUser.uid)
    const testData = await getDoc(accountRef);
    setaccountModel(testData.data())
    setUserAccountDetails(testData.data())

    // get pets if shelter
    if (accountModel.type == "Shelter") {
      const petImageRef = ref(storage, 'images/pets/')
      const petRef = collection(db, "pets")
      const petData = query(petRef, where("shelterID", "==", currentUser.uid))
      onSnapshot(petData, (snapshot) => {
        let pets = []
        snapshot.docs.forEach(doc => {
          getDownloadURL(ref(storage, `images/pets/${doc.id}`)).then((url) => {
            setPetImages(prev => ({...prev, [doc.id]: url
            }));
          })
          pets.push({...doc.data(), id: doc.id})
        })
        setShelterPets(pets)
        console.log(petImages)
    })

  }
  }

  useEffect(() => {
    if (currentUser?.photoURL) {
      setPhotoURL(currentUser.photoURL);
    }
      setLoading(false)
      getUsers();
  
  }, [mounted]);

  const saveInfo = async (e) => {
    e.preventDefault();
    const accountDetails = doc(db, "accounts", currentUser.uid)
    await updateDoc(accountDetails, {
      "user.firstname" : userAccountDetails.firstName || accountModel.user.firstname,
      "user.lastname" : userAccountDetails.lastName|| accountModel.user.lastname,
      "user.email" : userAccountDetails.email || accountModel.user.email,
      "user.userName" : userAccountDetails.userName || accountModel.user.userName,
      "contactInfo.email" : userAccountDetails.email || accountModel.contactInfo.email,
      "contactInfo.phoneNumber": userAccountDetails.phoneNumber || accountModel.contactInfo.phoneNumber,
      "contactInfo.city": userAccountDetails.city || accountModel.contactInfo.city,
      "contactInfo.street": userAccountDetails.street || accountModel.contactInfo.street,
      "contactInfo.state": userAccountDetails.state || accountModel.contactInfo.state,
      "contactInfo.zipCode": userAccountDetails.zipCode || accountModel.contactInfo.zipCode
    })
    .then(Response=> {
      console.log(Response.id)
    })
    .catch(error =>
      console.log(error.message))
  };

  const saveShelterInfo = async (e) => {
    e.preventDefault();
    const accountDetails = doc(db, "accounts", currentUser.uid)
    await updateDoc(accountDetails, {
      "shelter.name" : userAccountDetails.name || accountModel.shelter.name,
      "shelter.website" : userAccountDetails.website|| accountModel.shelter.website,
      "user.userName" : userAccountDetails.userName || accountModel.user.userName,
      "user.email" : userAccountDetails.email || accountModel.user.email,
      "contactInfo.email" : userAccountDetails.email || accountModel.contactInfo.email,
      "contactInfo.phoneNumber": userAccountDetails.phoneNumber || accountModel.contactInfo.phoneNumber,
      "contactInfo.city": userAccountDetails.city || accountModel.contactInfo.city,
      "contactInfo.street": userAccountDetails.street || accountModel.contactInfo.street,
      "contactInfo.state": userAccountDetails.state || accountModel.contactInfo.state,
      "contactInfo.zipCode": userAccountDetails.zipCode || accountModel.contactInfo.zipCode
    })
    .then(Response=> {
      console.log(Response.id)

    })
    .catch(error =>
      console.log(error.message))
  };

  const updatePet = async (id) => {
    // e.preventDefault();
    const petDetails = doc(db, "pets", id);
    handleUpdateClose();
    await updateDoc(petDetails, {
      "shelterID" : currentUser.uid,
      "name" : petFormFields.name,
      "species": petFormFields.species, 
      "breed": petFormFields.breed, 
      "disposition": petFormFields.disposition, 
      "availability": petFormFields.availability,
      "age": petFormFields.age,
      "description": petFormFields.description,
      "imgUrl": "www.image.com"
    })
    .then(Response=> {
      console.log(Response.id)
      

    })
    .catch(error =>
      console.log(error.message))
  };

  const deletePet = async (id) => {
    
    const petDoc = doc(db, "pets", id);
    console.log(petDoc)
    await deleteDoc(petDoc).then(() =>
      console.log("Doc deleted"))
  };
  
  const petCollectionsRef = collection(db, "pets")
  const createPet = async () => {
    await addDoc(petCollectionsRef, petFormFields);
  };

  const classes = useStyles();
  
  //Update Form
  const [openAdd, setOpenAdd] = React.useState(false);
  const [openUpdate, setOpenUpdate] = React.useState(false);
  const [selectedPet, setSelectedPet] = useState(null);

  const handleUpdateClickOpen = (pet) => {
    setSelectedPet(pet);
    setPetFormFields(pet);
    setOpenUpdate(true);
  };

  const handleAddClickOpen = () => {
    setOpenAdd(true);
  };

  const handleUpdateClose = () => {
    setSelectedPet(null);
    setOpenUpdate(false);
  };

  const handleAddClose = () => {
    setOpenAdd(false);
  };
  
  if (accountModel.type == "Adopter") {
    return (
      <div className='account'>
        <h1 className='account-header'>Setup Your Account</h1>
        <div className="account__container">
          <div className='account__items'>
            <li className='account__item'>
              <h1 className='account__item__text'>Profile Picture</h1>
            </li>
            <li className='account__item'>
              <figure className='account__item__pic-wrap'>
                <img
                  className='account__item__img'
                  alt='Profile Headshot'
                  src={photoURL}
                />
              </figure>
            </li>
            <div className='file_upload'>
              <Box pt={2} mx="auto">
                <label htmlFor="btn-upload" mt={1}> 
                    <input
                      id="btn-upload"
                      name="btn-upload"
                      style={{ display: 'none' }}
                      type="file"
                      accept="image/*"
                      onChange={handlePicChange} 
                      />
                    <Button sx={{mr: 4}}
                      className="btn-choose"
                      variant="contained"
                      component="span" >
                      Choose Image
                    </Button>
                </label>
                <Button variant="contained" component="span" disabled={!loading || !photo} onClick={handlePicClick}>Upload</Button>
              </Box>
            </div>
          </div>
          <div className='account__items__rows'>
              <h2 className='account__item__text'>Account Details</h2>
          </div>
          <Box sx={{ width: "80%" }} >
            <div>
              <TextField 
                  sx={{marginTop: 3,
                      marginBottom: 3,
                      display: 'block' }}
                  variant="filled"
                  type="text" 
                  name="username" 
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">User Name:   </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.user.userName }
                  value={ userAccountDetails.userName }
                  onChange={e => setUserAccountDetails({...userAccountDetails, userName: e.target.value})}
                /> 
              <TextField                   
                  sx={{marginTop: 3,
                      marginBottom: 3,
                      display: 'block' }} 
                  variant="filled"
                  type="email" 
                  name="email" 
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Email:   </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.user.email }
                  value={ userAccountDetails.email }
                  onChange={e => setUserAccountDetails({...userAccountDetails, email: e.target.value})}
              />
                <TextField                   
                  sx={{marginTop: 3,
                      marginBottom: 3,
                      display: 'block' }} 
                  variant="filled"
                  type="text" 
                  name="firstname" 
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">First Name:   </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.user.firstname }
                  value={ userAccountDetails.firstName }
                  onChange={e => setUserAccountDetails({...userAccountDetails, firstName: e.target.value})}
              />
               <TextField                   
                  sx={{marginTop: 3,
                      marginBottom: 3,
                      display: 'block' }} 
                  variant="filled"
                  type="text" 
                  name="firstname" 
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Last Name:   </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.user.lastname }
                  value={ userAccountDetails.lastName }
                  onChange={e => setUserAccountDetails({...userAccountDetails, lastName: e.target.value})}
              />
              </div> 
              </Box>
        
          <div className='account__items__rows'>
              <h2 className='account__item__text'>Contact Information</h2>
          </div>

          <Box sx={{ width: "80%" }}> 
          <TextField 
                  sx={{marginTop: 3,
                    marginBottom: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='number'
                  name='number'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Phone Number:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.phoneNumber }
                  value={ userAccountDetails.phoneNumber }
                  onChange={e => setUserAccountDetails({...userAccountDetails, phoneNumber: e.target.value})}
                />
            <TextField 
                  sx={{marginTop: 3,
                    marginBottom: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='text'
                  name='street'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Street:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.street }
                  value={ userAccountDetails.street }
                  onChange={e => setUserAccountDetails({...userAccountDetails, street: e.target.value})}
                />
            <TextField 
                  sx={{marginTop: 3,
                    marginBottom: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='text'
                  name='city'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">City:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.city }
                  value={ userAccountDetails.city }
                  onChange={e => setUserAccountDetails({...userAccountDetails, city: e.target.value})}
                />
            <TextField 
                  sx={{marginTop: 3,
                    marginBottom: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='text'
                  name='state'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">State:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.state }
                  value={ userAccountDetails.state }
                  onChange={e => setUserAccountDetails({...userAccountDetails, state: e.target.value})}
                />
            <TextField 
                  sx={{marginTop: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='number'
                  name='zipcode'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">ZipCode:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.zipCode }
                  value={ userAccountDetails.zipCode }
                  onChange={e => setUserAccountDetails({...userAccountDetails, zipCode: e.target.value})}
                />
            </Box>

          {/* <Link to='/browse' className='btn-link'> */}
            <button onClick={saveInfo} className='account-input-btn' type='submit'>
              Save
            </button>
          {/* </Link> */}
          
        </div>
        </div>
      
    );
  } else if (accountModel.type == "Shelter") {
      return (
      <div className='account'>
        <h1 className='account-header'>Setup Your Account</h1>
        <div className="account__container">
        <div className='account__items'>
            <li className='account__item'>
              <h1 className='account__item__text'>Profile Picture</h1>
            </li>
            <li className='account__item'>
              <figure className='account__item__pic-wrap'>
                <img
                  className='account__item__img'
                  alt='Profile Headshot'
                  src={photoURL}
                />
              </figure>
            </li>
            <div className='file_upload'>
              {/* <label for="file_upload" >
                  <Button variant="contained" component="span" class="fa fa-cloud-upload" href="#contained-buttons">Change Profile Picture</Button>
              </label> */}
              <Box pt={2} mx="auto">
                <label htmlFor="btn-upload" mt={1}> 
                    <input
                      id="btn-upload"
                      name="btn-upload"
                      style={{ display: 'none' }}
                      type="file"
                      accept="image/*"
                      onChange={handlePicChange} 
                      />
                    <Button sx={{mr: 4}}
                      className="btn-choose"
                      variant="contained"
                      component="span" >
                      Choose Image
                    </Button>
                </label>
                <Button variant="contained" component="span" disabled={!loading || !photo} onClick={handlePicClick}>Upload</Button>
              </Box>
            </div>
            {/* <div>
              <label htmlFor="contained-button-file">
                <Button variant="contained" component="span" hidden={!loading || !photo} onClick={handlePicClick}>
                  Save
                </Button>
              </label>
              <label htmlFor="icon-button-file">
                <Input accept="image/*" id="icon-button-file" type="file" />
                <IconButton color="primary" aria-label="upload picture" component="span" onClick={handlePicClick}>
                  <PhotoCamera />
                </IconButton>
              </label>
            </div> */}
          </div>
          <div className='account__items__rows'>
              <h2 className='account__item__text'>Account Details</h2>
          </div>
          <Box sx={{ width: "80%" }} >
            <div>
              <TextField 
                  sx={{marginTop: 3,
                      marginBottom: 3,
                      display: 'block' }}
                  variant="filled"
                  type="text" 
                  name="username" 
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">User Name:   </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.user.userName }
                  value={ userAccountDetails.userName }
                  onChange={e => setUserAccountDetails({...userAccountDetails, userName: e.target.value})}
                /> 
              <TextField                   
                  sx={{marginTop: 3,
                      marginBottom: 3,
                      display: 'block' }} 
                  variant="filled"
                  type="email" 
                  name="email" 
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Email:   </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.user.email }
                  value={ userAccountDetails.email }
                  onChange={e => setUserAccountDetails({...userAccountDetails, email: e.target.value})}
              /> 
              <TextField 
                  sx={{marginTop: 3,
                      marginBottom: 3,
                      display: 'block' }} 
                  variant="filled"
                  type='text'
                  name='name'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Name:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.name }
                  value={ userAccountDetails.name }
                  onChange={e => setUserAccountDetails({...userAccountDetails, name: e.target.value})}
              /> 
              <TextField 
                  sx={{marginTop: 3,
                    marginBottom: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='text'
                  name='website'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Website:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.website }
                  value={ userAccountDetails.website }
                  onChange={e => setUserAccountDetails({...userAccountDetails, website: e.target.value})}
                />
            </div>
          </Box>
          <div className='account__items__rows'>
              <h2 className='account__item__text'>Contact Information</h2>
          </div>
          <Box sx={{ width: "80%" }}> 
          <TextField 
                  sx={{marginTop: 3,
                    marginBottom: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='number'
                  name='number'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Phone Number:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.phoneNumber }
                  value={ userAccountDetails.phoneNumber }
                  onChange={e => setUserAccountDetails({...userAccountDetails, phoneNumber: e.target.value})}
                />
            <TextField 
                  sx={{marginTop: 3,
                    marginBottom: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='text'
                  name='street'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">Street:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.street }
                  value={ userAccountDetails.street }
                  onChange={e => setUserAccountDetails({...userAccountDetails, street: e.target.value})}
                />
            <TextField 
                  sx={{marginTop: 3,
                    marginBottom: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='text'
                  name='city'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">City:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.city }
                  value={ userAccountDetails.city }
                  onChange={e => setUserAccountDetails({...userAccountDetails, city: e.target.value})}
                />
            <TextField 
                  sx={{marginTop: 3,
                    marginBottom: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='text'
                  name='state'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">State:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.state }
                  value={ userAccountDetails.state }
                  onChange={e => setUserAccountDetails({...userAccountDetails, state: e.target.value})}
                />
            <TextField 
                  sx={{marginTop: 3,
                    display: 'block' }} 
                  variant="filled"
                  type='number'
                  name='zipcode'
                  fullWidth
                  InputProps={{
                    startAdornment: <InputAdornment position="start">ZipCode:  </InputAdornment>,
                  }}
                  placeholder={ accountModel && accountModel.contactInfo.zipCode }
                  value={ userAccountDetails.zipCode }
                  onChange={e => setUserAccountDetails({...userAccountDetails, zipCode: e.target.value})}
                />
            </Box>
          {/* <Link to='/browse' className='btn-link'> */}
            <button onClick={saveShelterInfo} className='account-input-btn' type='submit'>
              Save
            </button>
          {/* </Link> */}
          <div className="account__container">
            <br></br>
            
            <Button size="large" variant='contained' startIcon={<AddIcon />} onClick={toggle}>Manage Current Pets</Button>
                {mounted && shelterPets.map((pet, index) => {
                  return (
                    <Grid 
                      container   
                      direction="row"
                      justifyContent="center"
                      alignItems="center">
                      <Grid item xs={10} sx={{
                        margin: "8px",  
                        boxShadow: "0 8px 40px -12px rgba(0,0,0,0.3)",
                        "&:hover": {
                          boxShadow: "0 16px 70px -12.125px rgba(0,0,0,0.3)"
                        }}}>
                          <Card variant="outlined" sx={{ display: 'flex', background: "#fffaf0" }}>
                              <CardMedia
                                component="img"
                                image={petImages[pet.id]}
                                sx={{ width: 200 }}
                                alt=".\public\images\D5.jpg">
                              </CardMedia>
                              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <CardContent sx={{ flex: '1 0 auto' }}>
                                
                                  <Typography gutterBottom variant="h4" component="div"> {pet.name}</Typography>
                                  <Divider/>
                                    <Typography sx={{ fontSize: 18, marginTop: "4px"}} variant="body2" color="text.secondary"> Animal: {pet.species} </Typography>
                                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Age: {pet.age} </Typography>
                                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Species: {pet.species} </Typography>
                                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Breed: {pet.breed} </Typography>
                                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Disposition: {pet.disposition} </Typography>
                                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Description: {pet.description} </Typography>
                                    <Typography sx={{ fontSize: 18 }} variant="body2" color="text.secondary"> Availability: {pet.availability} </Typography>
                                  <CardActions>

                                  {/* <label htmlFor="btn-upload" mt={1}> 
                                          <input
                                            id="btn-upload"
                                            name="btn-upload"
                                            style={{ display: 'none' }}
                                            type="file"
                                            accept="image/*"
                                            onChange={(event) => { setImageUpload(event.target.files[0])}}
                                            />
                                        <Button size="small" color="primary" variant='outlined' onClick={uploadImage(pet.id)}>Upload Image</Button>
                                        </label> */}
                                    <Button size="small" color="primary" variant='outlined' onClick={() => handleUpdateClickOpen(pet)}>
                                      Modify
                                    </Button>
                                    <Dialog open={openUpdate} onClose={handleUpdateClose}>
                                      <DialogTitle>{selectedPet && selectedPet.name}</DialogTitle>
                                      <DialogContent>
                                        
                                        
                                        {/* <TextField
                                          autoFocus
                                          margin="dense"
                                          id="species"
                                          label="Species"
                                          fullWidth
                                          variant="standard"
                                          type='text'
                                          name='species'
                                          value={ petFormFields.species }
                                          placeholder={ selectedPet && selectedPet.species }
                                          onChange={e => setPetFormFields({...petFormFields, species: e.target.value})}
                                        /> */}
                                        <Dropdown def={ petFormFields.species } name={'species'} label={"Species"} options={["dog", "cat", "other"]} onChange={e => setPetFormFields({...petFormFields, species: e.target.value})} />
                                        { selectedPet && selectedPet.species == "cat"  &&
                                    <Dropdown def={ petFormFields.breed } name={'breed'} label={"Breed"} options={selectedPet.species=="dog" ? dogBreeds : catBreeds } onChange={e => setPetFormFields({...petFormFields, breed: e.target.value})} />}
                                    {  selectedPet && selectedPet.species == "dog" &&
                                      <Dropdown def={ petFormFields.breed } name={'breed'} label={"Breed"} options={selectedPet.species=="dog" ? dogBreeds : catBreeds } onChange={e => setPetFormFields({...petFormFields, breed: e.target.value})} />}
                                    <Dropdown def={ petFormFields.disposition} name={'disposition'} label={"Disposition"} options={Disposition} onChange={e => setPetFormFields({...petFormFields, disposition: e.target.value})} />
                                    <Dropdown def={ petFormFields.availability } name={'availability'} label={"Availability"} options={["pending", "not available", "available", "adopted"]} onChange={e => setPetFormFields({...petFormFields, availability: e.target.value})} />
                                        {/* <TextField
                                          autoFocus
                                          margin="dense"
                                          id="breed"
                                          label="Breed"
                                          fullWidth
                                          variant="standard"
                                          type='text'
                                          name='breed'
                                          value={ petFormFields.breed }
                                          placeholder={ selectedPet && selectedPet.breed }
                                          onChange={e => setPetFormFields({...petFormFields, breed: e.target.value})}
                                        /> */}
                                        <TextField
                                          autoFocus
                                          margin="dense"
                                          id="name"
                                          label="Name"
                                          fullWidth
                                          variant="standard"
                                          type='text'
                                          name='name'
                                          value={ petFormFields.name }
                                          placeholder={ selectedPet && selectedPet.name }
                                          onChange={e => setPetFormFields({...petFormFields, name: e.target.value})}
                                        />
                                        <TextField
                                          autoFocus
                                          margin="dense"
                                          id="age"
                                          label="Age"
                                          fullWidth
                                          variant="standard"
                                          type='number'
                                          name='age'
                                          value={ petFormFields.age }
                                          placeholder={ selectedPet && selectedPet.age }
                                          onChange={e => setPetFormFields({...petFormFields, age: e.target.value})}
                                        />
                                        <TextField
                                          autoFocus
                                          margin="dense"
                                          id="description"
                                          label="Description"
                                          fullWidth
                                          variant="standard"
                                          type='text'
                                          name='description'
                                          value={ petFormFields.description }
                                          placeholder={ selectedPet && selectedPet.description }
                                          onChange={e => setPetFormFields({...petFormFields, description: e.target.value})}
                                        />
                                        {/* <TextField
                                          autoFocus
                                          margin="dense"
                                          id="distposition"
                                          label="Disposistion"
                                          fullWidth
                                          variant="standard"
                                          type='text'
                                          name='disposition'
                                          value={ petFormFields.disposition }
                                          placeholder={ selectedPet && selectedPet.disposition }
                                          onChange={e => setPetFormFields({...petFormFields, disposition: e.target.value})}
                                        /> */}
                                        <DialogContentText>
                                          Change {selectedPet && selectedPet.name}'s Picture
                                        </DialogContentText>
                                        <input
                                          type="file"
                                          onChange={(event) => {
                                            setImageUpload(event.target.files[0]);
                                          }}
                                        />
                                        
                                        <Button onClick={() => uploadImage(selectedPet.id)}> Upload Pet Image</Button>
                                      </DialogContent>
                                      <DialogActions>

                                        <Button onClick={handleUpdateClose}>Close</Button>
                                        <Button onClick={() => updatePet(selectedPet.id)}>Save Changes</Button>

                                      </DialogActions>
                                    
                                    </Dialog>
                                    <Button size="small" startIcon={<DeleteIcon />} color="primary" variant='outlined' onClick={() => deletePet(pet.id)}>
                                      Delete
                                    </Button>
                                    
                                  </CardActions>
  
                                </CardContent>
                                </Box>
                          </Card>
                        </Grid>
                    </Grid>
                  );
                })}

              <Button color="success" variant='contained' startIcon={<AddIcon />} sx={{margin: "8px"}} onClick={handleAddClickOpen}>
                Add Pet
              </Button>
              <Dialog open={openAdd} onClose={handleAddClose}>
                <DialogTitle>Add a pet</DialogTitle>
                
                  <Dropdown def={petFormFields.species} name={'species'} label={"Species"} options={["dog", "cat", "other"]} onChange={e => setPetFormFields({...petFormFields, species: e.target.value})} />

                  {/* <TextField
                    autoFocus
                    margin="dense"
                    id="species"
                    label="Species"
                    fullWidth
                    variant="standard"
                    type='text'
                    name='species'
                    onChange={e => setPetFormFields({...petFormFields, species: e.target.value})}
                  /> */}
                  {petFormFields.species == "cat"  &&
                  <Dropdown def={petFormFields.breed} name={'breed'} label={"Breed"} options={petFormFields.species=="dog" ? dogBreeds : catBreeds } onChange={e => setPetFormFields({...petFormFields, breed: e.target.value})} />}
                  { petFormFields.species == "dog" &&
                    <Dropdown def={petFormFields.breed} name={'breed'} label={"Breed"} options={petFormFields.species=="dog" ? dogBreeds : catBreeds } onChange={e => setPetFormFields({...petFormFields, breed: e.target.value})} />}
                  <Dropdown def={petFormFields.disposition} name={'disposition'} label={"Disposition"} options={Disposition} onChange={e => setPetFormFields({...petFormFields, disposition: e.target.value})} />
                  {/* <TextField
                    autoFocus
                    margin="dense"
                    id="breed"
                    label="Breed"
                    fullWidth
                    variant="standard"
                    type='text'
                    name='breed'
                    onChange={e => setPetFormFields({...petFormFields, breed: e.target.value})}
                  /> */}
                  <DialogContent>
                  <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    fullWidth
                    variant="standard"
                    type='text'
                    name='name'
                    onChange={e => setPetFormFields({...petFormFields, name: e.target.value})}
                  />
                  <TextField
                    autoFocus
                    margin="dense"
                    id="age"
                    label="Age"
                    fullWidth
                    variant="standard"
                    type='number'
                    name='age'
                    onChange={e => setPetFormFields({...petFormFields, age: e.target.value})}
                  />
                  <TextField
                    autoFocus
                    margin="dense"
                    id="description"
                    label="Description"
                    fullWidth
                    variant="standard"
                    type='text'
                    name='description'
                    onChange={e => setPetFormFields({...petFormFields, description: e.target.value})}
                  />
                  {/* <TextField
                    autoFocus
                    margin="dense"
                    id="distposition"
                    label="Disposistion"
                    fullWidth
                    variant="standard"
                    type='text'
                    name='disposition'
                    onChange={e => setPetFormFields({...petFormFields, disposition: e.target.value})}
                  /> */}
                

                </DialogContent>
                <DialogActions>
                  <Button onClick={handleAddClose}>Close</Button>
                  <Button onClick={createPet}>Save Changes</Button>
                </DialogActions>
                </Dialog>
        </div>
        </div>
      </div>
    );
  }
}


export default Account;